var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodPracticeStatement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#A02524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3846 13.0769C13.1461 13.0769 15.3846 10.8383 15.3846 8.07692C15.3846 5.3155 13.1461 3.07692 10.3846 3.07692C7.62322 3.07692 5.38464 5.3155 5.38464 8.07692C5.38464 10.8383 7.62322 13.0769 10.3846 13.0769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.3H9.5C8.67157 14.3 8 14.9716 8 15.8C8 16.6284 8.67157 17.3 9.5 17.3H10.5C11.3284 17.3 12 16.6284 12 15.8C12 14.9716 11.3284 14.3 10.5 14.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.6846H9.50003C8.88402 14.6846 8.38464 15.184 8.38464 15.8C8.38464 16.416 8.88402 16.9154 9.50003 16.9154H10.5C11.116 16.9154 11.6154 16.416 11.6154 15.8C11.6154 15.184 11.116 14.6846 10.5 14.6846Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4615 12.3H7.53846C6.68879 12.3 6 12.9888 6 13.8385V14.7615C6 15.6112 6.68879 16.3 7.53846 16.3H12.4615C13.3112 16.3 14 15.6112 14 14.7615V13.8385C14 12.9888 13.3112 12.3 12.4615 12.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4616 12.6846H7.53849C6.90124 12.6846 6.38464 13.2012 6.38464 13.8385V14.7615C6.38464 15.3988 6.90124 15.9154 7.53849 15.9154H12.4616C13.0988 15.9154 13.6154 15.3988 13.6154 14.7615V13.8385C13.6154 13.2012 13.0988 12.6846 12.4616 12.6846Z",
    stroke: "#A02524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodPracticeStatement);
export default __webpack_public_path__ + "static/media/good-practice-statement.a4d4f8f98690b0a5f47ef028b74068b3.svg";
export { ForwardRef as ReactComponent };